import Vue from 'vue';
import VueHotkey from 'v-hotkey';

// add any custom shortkey config settings here

Vue.use(VueHotkey);

export default VueHotkey;
